/**
 * A dedicated function for handling specific case or intermediate processes,
 * which require certain product(s) to be indifferent (or not impactful) on
 * available periods or tariffs.
 * This is a specific function to unify such process and provide a single function
 * which can control such behavior across the code.
 *
 * @param {object} product
 * @return {boolean}
 */
export default (product) => {
    return product?.product_id === 6;
}
